'use client';

import { c as _c } from "react/compiler-runtime";
import { StytchB2BProvider } from '@stytch/nextjs/b2b';
import { createStytchB2BHeadlessClient } from '@stytch/nextjs/b2b/headless';
import env from 'lib/env';
import { installStytchSessionCookieOverride } from 'utils/stytch-session-cookies';
import type { ReactElement } from 'react';

// Must run before createStytchB2BHeadlessClient so every Stytch cookie write
// (initial auth + the ~3-min JWT refresh) lands as a browser-session cookie
// that clears on browser close. Server-side session lifetime is unchanged.
installStytchSessionCookieOverride();
const stytchClient = createStytchB2BHeadlessClient(env.NEXT_PUBLIC_STYTCH_B2B_PUBLIC_TOKEN);
export default function StyctchProviderWrapper(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <StytchB2BProvider stytch={stytchClient}>{children}</StytchB2BProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}